jQuery(function($){

  $('.form-action-button').click(function(){
    var $form = $($(this).data('form-id'));
    if($form.length){
      $form.find('.msg-success').hide();
      var $inputs = $form.find('.field__input');
      if($inputs.length){
        var $fields = [];
        var $name   = '';
        var $email   = '';
        var $error_msgs = '';
        $inputs.each(function(){
          var $input = $(this);
          if($input.hasClass('required') && $input.val()==''){
            $input.addClass('error');
            $error_msgs += '<li>'+ $input.data('error-msg') +'</li>';
          } else {
            //if email validate email
            $fields.push([$input.attr('name'),$input.next().text(),$input.val()]);

            if($input.attr('name')=='name'){
              $name = $input.val();
            }
            if($input.attr('name')=='email'){
              $email = $input.val();
            }
            
          }
        });

        if($error_msgs){
          $form.find('.msg-error').html('<ul>'+ $error_msgs +'</ul>').show();
          $('html, body').animate({scrollTop:$form.offset().top - 100}, 500);
        } else {
          createZenTicket($name,$email,$fields,$form);
        }
      }
    }
    return false;
  });


  function createZenTicket(name,email,fields,form){
    var zToken   = 'b0BJn2fHCMiQWvCnvQfnzplVbithr0aBvndHcQJs';
    var zSubject = form.data('zendesk-subject');
    var zDomain = 'asprey';

    if(zToken==''){
      form.find('.msg-error').html('<ul><li>Configuration Error: ZenDesk API Token not set</li></ul>').show();
      return false;
    }
    if( $('.field_product-name').val() != ''){
      zSubject = 'Product Enquiry: ' + $('.field_product-name').val();
    }else if(zSubject == ''){
      zSubject = 'Website Contact form submission';
    }

    let bodyHTML = $('#zendesk-email-header').html();
    bodyHTML += '<table align="center" style="border-collapse: collapse; margin: 0 auto; text-align: left; width: 660px">';
    fields.forEach((field) => {
      bodyHTML += '<tr><td style="width:25%;border: 1px solid #eaeaea;  font-size: 12px; padding: 7px 9px 9px; vertical-align: top">'+ field[1] +'</th><td style="border: 1px solid #eaeaea;  font-size: 12px; padding: 7px 9px 9px; vertical-align: top">'+ field[2] +'</td></tr>'
    });
    bodyHTML += '</table>';
    bodyHTML += $('#zendesk-email-footer').html();
    
    var zenHeaders = new Headers();
    zenHeaders.append("Authorization", "Basic btoa("+ email +"/token:"+ zToken +")");
    zenHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "request": {
        "requester": { "name": name, "email": email },
        "subject": zSubject,
        "comment": { "html_body": bodyHTML },
      },
    });
    
    var requestOptions = {
      method: 'POST',
      headers: zenHeaders,
      body: raw,
      redirect: 'follow'
    
    };

    fetch("https://"+ zDomain +".zendesk.com/api/v2/requests", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then(result =>{ 
        //console.log(result);
        
        if(result.hasOwnProperty('request') && result.request.hasOwnProperty('id')&& result.request.id!=''){
          form.find('.field__input').val('');
          form.find('.field,.contact__button,.msg-error').hide();
          form.find('.msg-success').show();
          
        } else if(result.hasOwnProperty('details') && result.details.hasOwnProperty('requester')) {
          form.find('.msg-success').hide();
          form.find('.msg-error').html(result.details.requester[0].description).show();
        }
        $('html, body').animate({scrollTop:form.offset().top - 120}, 500);
      })
      .catch(error => { 
        form.find('.msg-success').hide();
        form.find('.msg-error').html('Error submitting your request. Please try again.').show();
        $('html, body').animate({scrollTop:form.offset().top - 120}, 500);
      });
  }


  

  //create_zen_ticket()
  
});
